import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { defineOptions } from "vue";


export default /*#__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'InputField',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!

  return (_openBlock(), _createBlock(_component_v_text_field, _mergeProps({
    class: "custom-text-field",
    density: "compact"
  }, _ctx.$attrs, { variant: "outlined" }), null, 16))
}
}

})